<template>
<div class="chapter">
<div class="inner_page">
<h2 id="toc" title="Title Page">Law and the Bible</h2>
<p class="h3">Justice, Mercy and Legal Institutions</p>
<p class="h3"> </p>
<p class="h3">Edited by Robert F. Cochran Jr. and David VanDrunen</p>
<p class="firstcenter"><img alt="IVP Books Imprint" src="Images/IVP_Academic_Quarter.jpg"/></p>
<p class="center"><a href="http://www.IVPress.com/books" target="_blank">www.IVPress.com/ books</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?37089d9c